/** Name of the feature. */
export const SolanaSignAndSendTransaction = 'solana:signAndSendTransaction';
//# sourceMappingURL=signAndSendTransaction.js.map